import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faTimes,
  faHome,
  faInfoCircle,
  faHandshake,
  faEnvelope,
  faShieldAlt,
  faTachometerAlt,
  faSignOutAlt,
  faUserPlus,
  faSignInAlt,
} from '@fortawesome/free-solid-svg-icons';
import './Navbar.css';
import logo from '../Images/myapoti_logo_pot.png';
import AuthService from '../AuthService/AuthService';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Update login status on every route change
    setIsLoggedIn(AuthService.isLoggedIn());
  }, [location]);

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  const handleLogout = () => {
    AuthService.clearTokens();
    setIsLoggedIn(false);
    navigate('/');
    window.location.reload();
  };

  return (
    <nav className="myapoti-navbar">
      <div className="nav-content">
        <Link to="/" className="nav-logo" onClick={() => setIsMenuOpen(false)}>
          <img src={logo} alt="MyApoti" />
        </Link>

        <div className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          <Link to="/" onClick={() => setIsMenuOpen(false)}>
            <FontAwesomeIcon icon={faHome} className="nav-icon" /> Home
          </Link>

          {!isLoggedIn && (
            <>
              <Link to="/AboutUs" onClick={() => setIsMenuOpen(false)}>
                <FontAwesomeIcon icon={faInfoCircle} className="nav-icon" /> About Us
              </Link>
              <Link to="/AmbassadorProgram" onClick={() => setIsMenuOpen(false)}>
                <FontAwesomeIcon icon={faHandshake} className="nav-icon" /> Ambassador Program
              </Link>
              {/* <Link to="/signup" onClick={() => setIsMenuOpen(false)}>
                <FontAwesomeIcon icon={faUserPlus} className="nav-icon" /> Signup
              </Link>
              <Link to="/login" onClick={() => setIsMenuOpen(false)}>
                <FontAwesomeIcon icon={faSignInAlt} className="nav-icon" /> Login
              </Link> */}
            </>
          )}

          <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
            <FontAwesomeIcon icon={faEnvelope} className="nav-icon" /> Contact
          </Link>
          <Link to="/PrivacyPolicy" onClick={() => setIsMenuOpen(false)}>
            <FontAwesomeIcon icon={faShieldAlt} className="nav-icon" /> Privacy Policy
          </Link>

          {/* {isLoggedIn && (
            <>
              <Link to="/dashboard" onClick={() => setIsMenuOpen(false)}>
                <FontAwesomeIcon icon={faTachometerAlt} className="nav-icon" /> Dashboard
              </Link>
              <button className="logout-btn" onClick={handleLogout}>
                <FontAwesomeIcon icon={faSignOutAlt} className="nav-icon" /> Logout
              </button>
            </>
          )} */}
        </div>

        <div className="manual-toggle-icon" onClick={toggleMenu}>
          <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
